<ngx-spinner bdColor="rgba(236,236,236,0.85)"
size="large"
color="#0099FF"
type="ball-clip-rotate"
template="<img src='assets/img/loading.gif' style='max-width:100px' />">
<p  class="pt-5">Loading ....</p>

</ngx-spinner>
<app-reminder-popup></app-reminder-popup>
<router-outlet></router-outlet>